import * as React from "react";
import { WithUser, WithUserProps } from "../../../helpers/UserDataProvider";
import { authGet } from "../../../utils/authenticatedRequest";
import { Button } from "semantic-ui-react";
import WrappedModal from "../../../components/WrappedModal";
import { firebaseDB, auth } from "../../../firebase";
const Download = require("downloadjs");

interface Props extends WithUserProps {}

interface State {
	isLoading: boolean;
	timerElapsed: boolean;
	error?: boolean;
	errorObj: any;
}

class UnderlyingDownloadContainer extends React.Component<Props, State> {
	state = {
		isLoading: false,
		errorObj: "",
		timerElapsed: false,
		error: false
	};
	timer: any;

	startDownload = () => {
		this.setState({ isLoading: true });

		this.timer = setTimeout(
			() => this.setState({ timerElapsed: true }),
			5000
		);

		authGet("pdf")
			.then(
				(response: Response) => response.blob()
				// () => {
				// 	this.setState({
				// 		error: true,
				// 		errorObj: fail,
				// 		isLoading: false
				// 	});
				// }
			)
			.then(blob => {
				clearTimeout(this.timer);
				this.setState({ isLoading: false, timerElapsed: false });

				Download(
					blob,
					`Business Plan - ${
						this.props.user.user.name
					} - ${new Date().toLocaleDateString()} - V${this.props.user
						.user.downloadCount || 1}.pdf`,
					"application/pdf"
				);

				firebaseDB
					.ref(`users/${auth.currentUser.uid}`)
					.update({
						downloadCount: this.props.user.user.downloadCount
							? this.props.user.user.downloadCount + 1
							: 2
					});
			})
			.catch(fail => {
				this.setState({
					error: true,
					errorObj: fail,
					isLoading: false
				});
			});
	};

	render() {
		return (
			<>
				<Button
					onClick={this.startDownload}
					loading={this.state.isLoading}
					primary
				>
					Download Business Plan
				</Button>
				<WrappedModal
					content={
						"Something went wrong, please try again! If the problem persists, please contact us. We apologise for the inconvenience"
					}
					isOpen={this.state.error}
					onClose={() => this.setState({ error: false })}
					title="Error!"
				/>
			</>
		);
	}
}

const DownloadContainer = WithUser(
	props =>
		props.user && props.user.isAuthed ? (
			<UnderlyingDownloadContainer {...props} />
		) : null
);

export default DownloadContainer;



// WEBPACK FOOTER //
// ./src/pages/BusinessPlanPage/components/DownloadContainer.tsx